"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _RegisterInstance = _interopRequireDefault(require("../../RegisterInstance"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

/**
 * Created by falknisius on 31.05.17.
 */
var GetFullFeedbacks = /*#__PURE__*/function () {
  function GetFullFeedbacks() {
    (0, _classCallCheck2["default"])(this, GetFullFeedbacks);
  }

  (0, _createClass2["default"])(GetFullFeedbacks, null, [{
    key: "askForFeedbacks",
    value: function () {
      var _askForFeedbacks = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var url, data, result, token;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('askForFeedbacks');

                if (_config["default"]) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return (0, _TimeoutHelper.timeout)(100);

              case 4:
                return _context.abrupt("return", GetFullFeedbacks.askForFeedbacks());

              case 5:
                if (_config["default"].feedbackRetrieveUrl) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(new Error('no feedback url found')));

              case 7:
                url = _BuildConstants.LEDGER_HOST + '/' + _config["default"].feedbackRetrieveUrl;
                data = {};
                _context.prev = 9;

                if (!_config["default"].backendUseBearerAuth) {
                  _context.next = 19;
                  break;
                }

                _context.next = 13;
                return _RegisterInstance["default"].getAccessToken('logAggregate:read');

              case 13:
                token = _context.sent;
                _context.next = 16;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, 'Bearer ' + token);

              case 16:
                result = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, null);

              case 21:
                result = _context.sent;

              case 22:
                if (!(result.status === 200)) {
                  _context.next = 26;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve({
                  name: 'update',
                  data: result.data
                }));

              case 26:
                return _context.abrupt("return", _promise["default"].reject(new Error('ERROR_HTTP_COMMUNICATION')));

              case 27:
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](9);
                console.error(_context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 29]]);
      }));

      function askForFeedbacks() {
        return _askForFeedbacks.apply(this, arguments);
      }

      return askForFeedbacks;
    }()
  }]);
  return GetFullFeedbacks;
}();

var _default = GetFullFeedbacks;
exports["default"] = _default;